import style from "modules/PsyProfile/components/Guarantees/style.module.scss"
import { DOMAIN_PREFIX } from "utils/env-management"
import { EmojiTag } from "components"
import { Text } from "ui-kit/components-branded/Text"

const GUARANTIES = [
    {
        imgLink: `${DOMAIN_PREFIX}/images/key-emoji.png`,
        title: "Конфиденциальность",
        description: (
            <>
                Ваша информация в&nbsp;безопасности и&nbsp;не&nbsp;передается третьим лицам. Только
                вы&nbsp;и&nbsp;психолог. Психологи подписывают соответствующее соглашение
                с&nbsp;нами.
            </>
        ),
    },
    {
        imgLink: `${DOMAIN_PREFIX}/images/credit-card-emoji.png`,
        title: "Возврат денег",
        description: (
            <>
                Вы&nbsp;можете отменить запись не&nbsp;позднее, чем за&nbsp;24&nbsp;часа
                до&nbsp;встречи. Деньги вернутся вам на&nbsp;карту.
            </>
        ),
    },
]

export function Guarantees() {
    return (
        <section className={style.container}>
            <h2 className={style.title} data-testid="psy-profile-guarantees-title">
                Наши гарантии
            </h2>
            <div className={style.content}>
                {GUARANTIES.map((guaranty, index) => (
                    <div className={style.item} key={index}>
                        <div className={style.emoji}>
                            <EmojiTag imgLink={guaranty.imgLink} className={style.emojiItem}>
                                {guaranty.title}
                            </EmojiTag>
                        </div>
                        <Text>{guaranty.description}</Text>
                    </div>
                ))}
            </div>
        </section>
    )
}
